import { exec } from "@kakaopay-common/payweb-core";
import { Browser } from "@kakaopay-common/user-agent";
import { INTERFACE, NONE_INDENTIFIER } from "../../constants.mjs";
function closeWebview(parameters) {
  if (!Browser.isPayWebview()) {
    console.warn("[closeWebview] it is not payweb. it will open with window.close()");
    if (window.opener !== null) {
      window.opener.KakaoPay.sendData(parameters == null ? void 0 : parameters.data);
    }
    window.close();
    return Promise.resolve({
      command: INTERFACE.CLOSE,
      success: true,
      extras: {
        identifier: NONE_INDENTIFIER
      }
    });
  }
  const command = {
    command: INTERFACE.CLOSE,
    ...parameters && { parameters }
  };
  return exec(command);
}
export {
  closeWebview
};
